import { runtime } from "./runtime.mjs";
function refreshPage() {
  runtime.refreshPage();
}
export {
  refreshPage
};
//# sourceMappingURL=refreshPage.mjs.map
